import React from 'react';
import { connect } from 'react-redux';
import { useMatch } from 'react-router-dom';
import { AppDispatch, RootState } from 'src/store/store';
import UnloadDoorScanPage from 'src/components/pages/unload-page/scan-door-page/UnloadDoorScanPage';
import { buildGetContainerDetailsInput, GetContainerMode } from 'src/models/GetContainerDetails';
import { DoorScanResult, Trailer } from 'src/models/unload';
import { DoorScanInput, scanDoor } from 'src/store/common-slices/unloadSlice';
import { UNLOAD_PALLET_PAGE_ROUTE } from 'src/routing/constants/routes';

interface Props {
    // The pallet route, where the step scans a pallet
    staging?: boolean;
    // The latest scan on this step, with its result
    lastScan?: DoorScanResult;
    // What was just closed, shown until the next scan
    closed?: Trailer;
    // End Orphan just returned to this step, which says so until the next scan
    orphanEnded: boolean;
    // The associate's site, sent with each call
    warehouseId: string;
    // The associate's id, sent with each call
    associate: string;
    // The associate's locale, sent with each call
    locale: string;
    // Sends a scan
    scanDoor: (input: DoorScanInput) => void;
}

// The slice opens the loop on a good scan and sounds every answer
export class UnloadDoorScanPageContainer extends React.Component<Props> {
    private onSubmit = (value: string) => this.props.scanDoor({ ...buildGetContainerDetailsInput(value,
        this.props.warehouseId, this.props.associate, this.props.locale, GetContainerMode.UNLOAD), pallet: this.props.staging });

    public render() {
        const { staging, lastScan, closed, orphanEnded } = this.props;
        return <UnloadDoorScanPage staging={staging} lastScan={lastScan} closed={closed} orphanEnded={orphanEnded}
                                   onSubmit={this.onSubmit}/>;
    }
}

// On the pallet route the step scans a pallet; useMatch runs the route's own matcher, so /unload-pallet/ counts too
const UnloadDoorScanPageOnRoute = (props: Omit<Props, 'staging'>) =>
    <UnloadDoorScanPageContainer {...props} staging={useMatch(UNLOAD_PALLET_PAGE_ROUTE) !== null}/>;

const mapStateToProps = (state: RootState) => ({
    lastScan: state.Unload.lastScan,
    closed: state.Unload.closed,
    orphanEnded: state.Unload.orphanEnded,
    warehouseId: state.Init.initData.gradingNodeDetails.id,
    associate: state.Init.initData.associateDetails.id,
    locale: state.Init.initData.associateDetails.locales[0]
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    scanDoor: (input: DoorScanInput) => dispatch(scanDoor(input))
});

export default connect(mapStateToProps, mapDispatchToProps)(UnloadDoorScanPageOnRoute);
